import { render, staticRenderFns } from "./SummitNavSample.vue?vue&type=template&id=11a38084&"
import script from "./SummitNavSample.vue?vue&type=script&lang=js&"
export * from "./SummitNavSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports